import React from 'react'
import './styles.scss'

export const AccountPage = () => {
  return <div className="account-page" />
}
